export const DEFAULT_CHART_HEIGHT = 350

export const getChartHeight = (height: number, legendHeight: number | undefined = 0, headerHeight: number | undefined = 0): number => {
  const toAdd: number = legendHeight + headerHeight

  return height + toAdd
}
